import React, { Component } from 'react';
import language from '../../assets/languages/language';
import AlertMessage from '../config/alertMessage';
import ModalComponent from '../Common/Modal';
import AppRoutes from '../config/AppRoutes';
import { renderHTMLContent } from '../../common/function';
import { nextAwareRoute } from '../../common/cfa1NextRoutes';

const LEFT_PAGE = 'LEFT';
const RIGHT_PAGE = 'RIGHT';
/**
 * Helper method for creating a range of numbers
 * range(1, 5) => [1, 2, 3, 4, 5]
 */
const range = (from, to, step = 1) => {
  let iterator = from;
  const range = [];

  while (iterator <= to) {
    range.push(iterator);
    iterator += step;
  }

  return range;
};
/* eslint-disable*/

class CommonDetailStatus extends Component {
  constructor(props) {
    super(props);
    var messageTitle_cfa = `<i class="icon-info icons font-2xl d-block "></i>`;
    // var messageContent_cfa = `<div class="modal-info-list"><ul> <li> ${
    //   language.LC().Extensive_Study_Notes
    // } </li> <li> ${language.LC().Hours_of_Video_Lessons_40} </li> <li> ${
    //   language.LC().Practice_Questions_3000
    // } </li> <li> ${language.LC().Unlimited_Customizable_Quizzes} </li> <li> ${
    //   language.LC().Amazing_Chat_Email_Support
    // }</li></ul></div>`;
    this.state = {
      currentPage: currentPage ? currentPage : 1,
      subscriptionstatus: this.props.subscriptionstatus,
      MessageContent: AlertMessage.messageContent_cfa_1,
      alert_status: false,
      selectedmenu: this.props.selectedmenu,
      level: this.props.level,
      offset: 0,
    };
    const {
      totalQuestions = '',
      currentPage = '',
      pageLimit = 20,
      pageNeighbours = 1,
      questionLowerLimit = 0,
      questionUpperLimit = 20,
    } = props;

    // console.log(typeof pageLimit)
    // console.log(pageLimit)
    // console.log(typeof totalQuestions)
    // console.log(totalQuestions)
    // PAGE LIMIT AND RECORDS
    this.pageLimit = typeof pageLimit === 'number' ? pageLimit : 20;
    this.totalQuestions = typeof totalQuestions === 'number' ? totalQuestions : 0;

    // PAGE NEIGHBOURS CAN BE 0, 1 OR 2
    this.pageNeighbours =
      typeof pageNeighbours === 'number' ? Math.max(0, Math.min(pageNeighbours, 2)) : 0;
    this.totalPages = Math.ceil(this.totalQuestions / this.pageLimit);
    // console.log(Math.ceil(this.totalQuestions / this.pageLimit))
  }

  executeOnClick(isExpanded) {
    // console.log(isExpanded);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  goPremium = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: storage_session['token'],
        idname: storage_session['idname'],
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  toggleAlert = () => {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  };

  componentDidUpdate(prevProps) {
    // console.log(this.props.level)
    // console.log("componentdidupdate");
    // console.log(prevProps);
    // console.log(this.props);
    if (
      this.state.currentPage !== this.props.currentPage &&
      prevProps.currentPage !== this.props.currentPage
    ) {
      this.setState({ currentPage: this.props.currentPage });
    }
    if (prevProps.totalQuestions !== this.props.totalQuestions) {
      // console.log("componentdidupdate");
      // console.log(this);
      const { totalQuestions, pageLimit } = this.props;
      // console.log(totalQuestions);
      // console.log(pageLimit)
      // console.log(Math.ceil(totalQuestions / pageLimit))
      let totPages = Math.ceil(totalQuestions / pageLimit);
      this.setState({
        totalQuestions,
        totalPages: totPages,
      });
    }
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  _beginChapter = (question, e) => {
    console.log(question);
    if (this.props.subscriptionstatus === 'free') {
      this.toggleAlert();
    } else {
      if (this.state.selectedmenu === 'frm') {
        const { chapter_id, reading_id, id } = question;
        const { level } = this.state;
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        this.context.router.push({
          pathname: AppRoutes.FRM_QUESTION_BANK_VIEW_QUESTION.replace(':notesid', chapter_id)
            .replace(':readingid', reading_id)
            .replace(':level', level)
            .replace(':id', id),
          state: {
            token: storage_session['token'],
            idname: storage_session['idname'],
            reading: reading_id,
            chapter: chapter_id,
            offset: 0,
            selectedMenu: 'frm',
          },
        });
      } else if (this.state.selectedmenu === 'cfa') {
        // console.log(question);
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        this.context.router.push({
          pathname:
            '/cfa1/beginchapter_2022/' +
            question.chapter_id_2022 +
            '/' +
            question.reading_id_2022 +
            '/' +
            question.id +
            '/' +
            this.state.offset,
          state: {
            token: storage_session['token'],
            idname: storage_session['idname'],
            reading: question.reading_id_2022,
            chapter: question.chapter_id_2022,
          },
        });
      } else if (this.state.selectedmenu === 'cfa_2023') {
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        // '/cfa1_2023/beginchapter/:notesid/:readingid/:id/:offset'
        this.context.router.push({
          pathname: AppRoutes.CFA1_2023_QUESTION_BANK_VIEW_QUE.replace(
            ':notesId',
            question.chapter_id_2023,
          )
            .replace(':readingId', question.reading_id_2023)
            .replace(':id', question.id)
            .replace(':offset', this.state.offset),
          state: {
            token: storage_session['token'],
            idname: storage_session['idname'],
            reading: question.reading_id_2023,
            chapter: question.chapter_id_2023,
          },
        });
      } else if (this.state.selectedmenu === 'cfa_2024') {
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        // '/cfa1_2023/beginchapter/:notesid/:readingid/:id/:offset'
        this.context.router.push({
          pathname: AppRoutes.CFA1_2024_QUESTION_BANK_VIEW_QUE.replace(
            ':notesid',
            question.chapter_id_2024,
          )
            .replace(':readingid', question.reading_id_2024)
            .replace(':id', question.id)
            .replace(':offset', this.state.offset),
          state: {
            token: storage_session['token'],
            idname: storage_session['idname'],
            reading: question.reading_id_2024,
            chapter: question.chapter_id_2024,
          },
        });
      } else if (this.state.selectedmenu === 'cfa_2025') {
        var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
        // '/cfa1_2023/beginchapter/:notesid/:readingid/:id/:offset'
        // selectedmenu is hardcoded 'cfa_2025' by the caller, so nextAwareRoute (which reads the
        // current URL) is what keeps a 2027 user on /cfa1/2027/... instead of the shared route.
        this.context.router.push({
          pathname: nextAwareRoute(AppRoutes.CFA1_2025_QUESTION_VIEW)
            .replace(':readingId', question.reading_id_2025)
            .replace(':questionId', question.id),
          state: {
            token: storage_session['token'],
            idname: storage_session['idname'],
            reading: question.reading_id_2025,
            chapter: question.chapter_id_2025,
          },
        });
      }
    }
  };

  allQuestionDataFun(data) {
    // console.log("data");
    // console.log(data);
    let dataRetun = '';
    if (data.length) {
      dataRetun = data.map((question, index) => {
        return (
          <tr key={index}>
            <td>{question.id}</td>
            {renderHTMLContent(question.question, 'td', '', { contentEditable: 'false' })}
            <td>{this.getChapterId(question)}</td>
            <td>{this.getReadingId(question)}</td>

            <td> {question.name} </td>
            {question.totalAttempt === null || question.totalAttempt === null ? (
              <td> {language.LC().NO} </td>
            ) : (
              <td> {language.LC().YES} </td>
            )}
            {question.totalAttempt === null || question.totalAttempt === null ? (
              <td> 0 </td>
            ) : (
              <td>{question.totalAttempt}</td>
            )}

            {question.avgScoreA === null && question.totalAttempt === null ? (
              <td> - </td>
            ) : question.avgScoreA === null && question.totalAttempt !== null ? (
              <td> 0% </td>
            ) : (
              <td>{parseInt(question.avgScoreA)}%</td>
            )}
            {/* {question.totalAttempt === 0 || question.totalAttempt === null ? (
              <td> - </td>
            ) : question.avgScoreA < 70 ? (
              <td> {language.LC().NO} </td>
            ) : (
              <td> {language.LC().YES} </td>
            )} */}
            <td>
              <span className='tooltip_wrap left-tool-tip margin_right_20'>
                <i
                  className={`fa fa-eye font-xl ${this.hasValidChapterAndReading(question) ? 'text_blue cursor-pointer' : 'text-muted'}`}
                  onClick={
                    this.hasValidChapterAndReading(question)
                      ? () => this._beginChapter(question)
                      : null
                  }
                />
                {this.hasValidChapterAndReading(question) ? (
                  <div className='tootip_box'>{language.LC().VIEW_QUESTION}</div>
                ) : null}
              </span>
            </td>
          </tr>
        );
      });
    } else {
      dataRetun = (
        <tr>
          <td colSpan='10'>
            <div className='text-center'>No Data Found</div>
          </td>
        </tr>
      );
    }
    return dataRetun;
  }

  /**
   * Retrieves the chapter ID from a question object based on the selected menu state.
   *
   * @param {Object} question - The question object containing various chapter IDs.
   * @returns {string|null} - The chapter ID corresponding to the current selected menu, or null if not available.
   */
  getChapterId = (question) => {
    const chapterIdMap = {
      cfa: 'chapter_id_2022',
      cfa_2023: 'chapter_id_2023',
      cfa_2024: 'chapter_id_2024',
      cfa_2025: 'chapter_id_2025',
      frm: 'chapter_id',
    };
    const key = chapterIdMap[this.state.selectedmenu];
    return question[key] !== undefined && question[key] !== null ? question[key] : null;
  };

  /**
   * Retrieves the reading ID from a question object based on the selected menu state.
   *
   * @param {Object} question - The question object containing various reading IDs.
   * @returns {string|null} - The reading ID corresponding to the current selected menu, or null if not available.
   */
  getReadingId = (question) => {
    const readingIdMap = {
      cfa: 'reading_id_2022',
      cfa_2023: 'reading_id_2023',
      cfa_2024: 'reading_id_2024',
      cfa_2025: 'reading_id_2025',
      frm: 'reading_id',
    };
    const key = readingIdMap[this.state.selectedmenu];
    return question[key] !== undefined && question[key] !== null ? question[key] : null;
  };

  /**
   * Determines if a question can be viewed by checking if it has valid chapter and reading IDs.
   *
   * @param {Object} question - The question object to be evaluated.
   * @returns {boolean} - Returns true if both chapter and reading IDs are present; otherwise, false.
   */
  hasValidChapterAndReading = (question) =>
    !!(this.getChapterId(question) && this.getReadingId(question));

  componentDidMount() {
    this.gotoPage(this.state.currentPage);
  }

  gotoPage = (page) => {
    const { onChangePagination = (f) => f } = this.props;
    const currentPage = Math.max(0, Math.min(page, this.totalPages));
    const paginationData = {
      currentPage,
      totalPages: this.totalPages,
      pageLimit: this.pageLimit,
      totalQuestions: this.totalQuestions,
    };
    return this.setState({ currentPage: page }, () => onChangePagination(page, paginationData));
  };

  // gotoPage only fires a setState + a fire-and-forget parent fetch (onChangePagination); it returns
  // nothing awaitable, so this stays a plain sync handler. (The parent owns the loading state.)
  handleClick = (page) => () => {
    this.gotoPage(page);
  };

  handleMoveLeft = () => {
    // console.log(this.state.currentPage - this.pageNeighbours * 2 - 1)
    this.gotoPage(this.state.currentPage - this.pageNeighbours * 2 - 1);
  };

  handleMoveRight = () => {
    // console.log(this.state.currentPage)
    // console.log(this.pageNeighbours)
    // console.log(this.state.currentPage - this.pageNeighbours * 2 + 1)
    this.gotoPage(this.state.currentPage + this.pageNeighbours * 2 + 1);
  };

  fetchPageNumbers = () => {
    const totalPages = this.state.totalPages;
    const currentPage = this.state.currentPage;
    const pageNeighbours = this.pageNeighbours;
    /**
     * totalNumbers: the total page numbers to show on the control
     * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
     */
    const totalNumbers = this.pageNeighbours * 2 + 3;
    const totalBlocks = totalNumbers + 2;
    if (totalPages > totalBlocks) {
      const startPage = Math.max(2, currentPage - pageNeighbours);
      const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
      let pages = range(startPage, endPage);
      /**
       * hasLeftSpill: has hidden pages to the left
       * hasRightSpill: has hidden pages to the right
       * spillOffset: number of hidden pages either to the left or to the right
       */
      const hasLeftSpill = startPage > 2;
      const hasRightSpill = totalPages - endPage > 1;
      const spillOffset = totalNumbers - (pages.length + 1);
      switch (true) {
        // handle: (1) < {5 6} [7] {8 9} (10)
        case hasLeftSpill && !hasRightSpill: {
          const extraPages = range(startPage - spillOffset, startPage - 1);
          pages = [LEFT_PAGE, ...extraPages, ...pages];
          break;
        }
        // handle: (1) {2 3} [4] {5 6} > (10)
        case !hasLeftSpill && hasRightSpill: {
          const extraPages = range(endPage + 1, endPage + spillOffset);
          pages = [...pages, ...extraPages, RIGHT_PAGE];
          break;
        }

        // handle: (1) < {4 5} [6] {7 8} > (10)
        case hasLeftSpill && hasRightSpill:
        default: {
          pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
          break;
        }
      }
      return [1, ...pages, totalPages];
    }
    return range(1, totalPages);
  };

  render() {
    // console.log('detail page')
    // console.log(this.props)
    const { allQuestionData, loader } = this.props;
    // console.log(this.totalPages)
    // if (!this.totalQuestions || this.totalPages === 1) return null;
    const { currentPage } = this.state;
    const pages = this.fetchPageNumbers();

    return (
      <div className='card'>
        <div className='card-block'>
          <div className='filter-table-wrap'>
            <table className='table-bordered responsive table table-striped table-hover'>
              <thead className='thead_color'>
                <tr>
                  <th> {language.LC().Question_ID} </th>
                  <th>{language.LC().QUESTION} </th>
                  <th>{language.LC().Chapter_No} </th>
                  <th>{language.LC().READING_No} </th>
                  <th> {language.LC().Reading_Name} </th>
                  <th> {language.LC().ANSWERED} </th>
                  <th> {language.LC().No_of_attempts} </th>
                  <th> {language.LC().AVERAGE_SCORE} </th>
                  {/* <th> {language.LC().Passing_Score}  </th> */}
                  <th> {language.LC().ACTION} </th>
                </tr>
              </thead>
              {loader ? (
                <div>
                  {' '}
                  <div className='loader_box'>
                    <div className='sk-circle'>
                      <div className='sk-circle1 sk-child' />
                      <div className='sk-circle2 sk-child' />
                      <div className='sk-circle3 sk-child' />
                      <div className='sk-circle4 sk-child' />
                      <div className='sk-circle5 sk-child' />
                      <div className='sk-circle6 sk-child' />
                      <div className='sk-circle7 sk-child' />
                      <div className='sk-circle8 sk-child' />
                      <div className='sk-circle9 sk-child' />
                      <div className='sk-circle10 sk-child' />
                      <div className='sk-circle11 sk-child' />
                      <div className='sk-circle12 sk-child' />
                    </div>
                  </div>{' '}
                </div>
              ) : (
                <tbody>{this.allQuestionDataFun(allQuestionData)}</tbody>
              )}
            </table>
          </div>

          <div className='pagination-wrapper'>
            <nav aria-label='Table Pagination'>
              <ul className='pagination justify-content-end'>
                {pages.map((page, index) => {
                  if (page === LEFT_PAGE)
                    return (
                      <li key={index}>
                        <p
                          className='page-link'
                          aria-label='Previous'
                          onClick={this.handleMoveLeft}
                        >
                          <span aria-hidden='true'>&laquo;</span>
                          <span className='sr-only'>Previous</span>
                        </p>
                      </li>
                    );

                  if (page === RIGHT_PAGE)
                    return (
                      <li key={index}>
                        <p
                          className='page-link'
                          aria-label='Next'
                          onClick={this.handleMoveRight}
                        >
                          <span aria-hidden='true'>&raquo;</span>
                          <span className='sr-only'>Next</span>
                        </p>
                      </li>
                    );

                  return (
                    <li key={index} className={`${currentPage === page ? ' active' : ''}`}>
                      <p className='page-link' onClick={this.handleClick(page)}>
                        {page}
                      </p>
                      {/* <a className='page-link' href='true' onClick={this.handleClick(page)}>
                        {page}
                      </a> */}
                    </li>
                  );
                })}
              </ul>
            </nav>
          </div>
        </div>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
      </div>
    );
  }
}

export default CommonDetailStatus;



// WEBPACK FOOTER //
// ./src/views/Common/CommonDetailStatus.js